export default {
  gapBetweenSections: '80px',
  gapBetweenSectionsSm: '40px',
  gapWithinSection: '20px',
  gapWithinNestedSection: '10px',
  defaultClasses: 'bg-white flex-column full-height'
};
